import { QueryKey, useMutation, useQuery, useQueryClient } from "react-query";
import { ApiServiceErr, MutOpt, PaginationOptions } from "../../types/api.types";
import api from ".";
import { ComplicationsResponse, CreateComplication, UpdateComplication } from "../../dto/request/complications-request.dto";
import { WFComplicationType, WFFamilyType } from "../../dto/WatchFace.dto";
import { ComplicationStatus, ComplicationType } from "../../dto/Complication.dto";

interface GetComplicationProps extends PaginationOptions {
    search?: string;
    slot?: string[];
    category?: string[];
    permission?: string[];
    familyType?: WFFamilyType
    status?: ComplicationStatus;
    type?: ComplicationType;
    complicationType?: WFComplicationType[]
}


export const COMPLICATIONS_KEY: QueryKey = ["COMPLICATIONS"];

const API_URL = '/admin/complications';

export function useGetComplications(props: GetComplicationProps) {
    const { page, limit, category, complicationType, familyType, permission, search, slot, status, type } = props;

    return useQuery<ComplicationsResponse, ApiServiceErr>(
        [...COMPLICATIONS_KEY, props],
        async () => {
            const response = await api.get<any>(
                API_URL,
                {
                    params: {
                        page,
                        limit,
                        familyType: familyType ? familyType[0] : undefined,
                        status: status ? status[0] : undefined,
                        type: type ? type[0] : undefined,
                        category,
                        complicationType: !!complicationType?.length ? complicationType : ['all'],
                        permission,
                        search,
                        slot,
                    }
                }
            );
            return response;
        },
        // opt,

    );
};

export const useUpdateComplication = (opt?: MutOpt<any>) => {
    const queryClient = useQueryClient();

    return useMutation<any, ApiServiceErr, { id: string, data: UpdateComplication }>(async ({ id, data }) => {
        const body = {
            ...data,
            position: +data.position
        }
        const response = await api.put(`/admin/complications/${id}`, body);

        return response.data;
    }, {
        ...opt,
        onSuccess: (data: any, variables: {
            id: string;
            data: UpdateComplication;
        }, context: unknown) => {
            queryClient.invalidateQueries(COMPLICATIONS_KEY);
            opt?.onSuccess?.(data, variables, context);
        }
    });
}


export const useCreateComplication = (opt?: MutOpt<any>) => {
    const queryClient = useQueryClient();
    return useMutation<any, ApiServiceErr, CreateComplication>(async (data: any) => {

        const formData = new FormData();
        console.log("🚀 ~ Object.keys ~ data:", data)

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    if (value.length === 1 && key !== 'slots') {
                        formData.append(`${key}[]`, value[0]);
                        return
                    }
                    for (var i = 0; i < value.length; i++) {
                        formData.append(`${key}`, value[i]);
                    }

                } else if (typeof value === 'object' && value !== null && !(value instanceof File)) {
                    formData.append(key, JSON.stringify(value))
                }
                else {
                    formData.append(key, value)
                }

            }
        });

        const response = await api.post(`/admin/complications`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    }, {
        ...opt,
        onSuccess: (data: any, variables: unknown, context: unknown) => {
            queryClient.invalidateQueries(COMPLICATIONS_KEY);
            opt?.onSuccess?.(data, variables, context);
        }
    })
};